
// Animation variants for contribution components
export const floatingElement = {
  initial: { scale: 0.9, opacity: 0 },
  animate: { 
    scale: 1, 
    opacity: 1,
    transition: { duration: 1.5, ease: "easeOut" }
  }
};

// Subtle wave animation for decorative elements
export const waveAnimation = {
  animate: {
    x: [0, 5, 0, -5, 0],
    y: [0, -5, 0, 5, 0],
    transition: {
      duration: 12,
      repeat: Infinity,
      repeatType: "reverse" as const,
      ease: "easeInOut"
    }
  }
};

// Animation for sparkle effects
export const sparkleAnimation = {
  animate: {
    scale: [1, 1.03, 1],
    transition: {
      duration: 2.5,
      repeat: Infinity,
      repeatType: "reverse" as const
    }
  }
};

// Glowing particle animations
export const glowingParticles = {
  animate: {
    opacity: [0.3, 0.8, 0.3],
    scale: [1, 1.2, 1],
    transition: {
      duration: 3,
      repeat: Infinity,
      repeatType: "reverse" as const
    }
  }
};

// Shimmering light effect animation
export const shimmerAnimation = {
  animate: {
    opacity: [0.4, 0.7, 0.4],
    scale: [1, 1.05, 1],
    transition: {
      duration: 5,
      repeat: Infinity,
      repeatType: "reverse" as const,
      ease: "easeInOut"
    }
  }
};

// Fade in from bottom animation
export const fadeInFromBottom = {
  initial: { opacity: 0, y: 20 },
  animate: { 
    opacity: 1, 
    y: 0,
    transition: { 
      duration: 0.6,
      ease: "easeOut"
    }
  }
};
